var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2963 6.05556H11.8148L11.8148 14.3889H15.2963V6.05556ZM18.7778 8.83333V3.27778C18.7778 1.74365 17.2191 0.5 15.2963 0.5H11.8148C9.89205 0.5 8.33333 1.74365 8.33333 3.27778V8.83333H3.11111C1.66903 8.83333 0.5 10.077 0.5 11.6111V18.5556V25.5V28.2778V35.2222V38V47.7222C0.5 49.2563 1.66904 50.5 3.11111 50.5H44.8889C46.331 50.5 47.5 49.2563 47.5 47.7222V38V35.2222V28.2778V25.5V18.5556V11.6111C47.5 10.077 46.331 8.83333 44.8889 8.83333H39.6667V3.27778C39.6667 1.74365 38.108 0.5 36.1852 0.5H32.7037C30.7809 0.5 29.2222 1.74365 29.2222 3.27778V8.83333H18.7778ZM42.2778 25.5V18.5556H35.75V25.5H42.2778ZM33.1389 25.5V18.5556H25.3056V25.5H33.1389ZM22.6944 25.5H14.8611V18.5556H22.6944V25.5ZM22.6944 28.2778V35.2222H14.8611V28.2778H22.6944ZM25.3056 35.2222V28.2778H33.1389V35.2222H25.3056ZM22.6944 38H14.8611V44.9444H22.6944V38ZM25.3056 44.9444V38H33.1389V44.9444H25.3056ZM35.75 38V44.9444H42.2778V38H35.75ZM35.75 28.2778V35.2222H42.2778V28.2778H35.75ZM12.25 25.5V18.5556H5.72222V25.5H12.25ZM5.72222 28.2778H12.25V35.2222H5.72222V28.2778ZM5.72222 44.9444V38H12.25V44.9444H5.72222ZM36.1852 6.05556V14.3889H32.7037V6.05556H36.1852Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/calendar-icon.26f4d14c2b5d4c66036e5b7bf3fb8dc2.svg";
export { ForwardRef as ReactComponent };